import { useEffect, useState } from "react";

const useNetworkStatus = () => {
    const [isOnline, setOnline] = useState(navigator.onLine);

    const updateNetworkStatus = () => {
        setOnline(navigator.onLine); 
    };

    useEffect(() => {
        window.addEventListener("online", updateNetworkStatus);
        window.addEventListener("offline", updateNetworkStatus);

        updateNetworkStatus();

        return () => {
            window.removeEventListener("online", updateNetworkStatus);
            window.removeEventListener("offline", updateNetworkStatus);
        };
    }, []);

    return { isOnline };
};

export default useNetworkStatus;
